import { bootstrapApplication } from '@angular/platform-browser';
import { viewConfig } from '../../ui/views/view.config';
import { MainView } from '../../ui/views/main/main.view';
import { Router } from '@angular/router';
import { monitorApplicationStartup, reportStartupFailure } from './startup-status';

bootstrapApplication(MainView, viewConfig)
  .then(app => monitorApplicationStartup(app.injector.get(Router), document))
  .catch(() => reportStartupFailure(document));
